import { bindContractSummary } from './bindData';

export const getContractSummary = (
  totalDiscount,
  totalPrice,
  translate,
  paymentFrequency,
  isFetchingPrice,
  insuredPeople,
  classes,
  language,
  handleOpenInsuredPeopleModal,
) => bindContractSummary(
  totalDiscount,
  totalPrice,
  translate,
  paymentFrequency,
  isFetchingPrice,
  insuredPeople,
  classes,
  language,
  handleOpenInsuredPeopleModal,
);

export const getTotalprice = (prices, paymentFrequency) => {
  let totalPrice = 0;
  Object.values(prices).forEach((price) => {
    if (price[paymentFrequency.value]) {
      totalPrice += price[paymentFrequency.value].sum;
    }
  });
  return Math.floor(totalPrice);
};

export const getDiscountedPrice = (prices, paymentFrequency) => {
  let totalPrice = 0;
  Object.values(prices).forEach((price) => {
    if (price[paymentFrequency.value]) {
      totalPrice += price[paymentFrequency.value].discountedSum;
    }
  });
  return Math.floor(totalPrice);
};

export const getDiscount = (prices, paymentFrequency) => {
  let totalPrice = 0;
  Object.values(prices).forEach((price) => {
    if (price[paymentFrequency.value]) {
      totalPrice += price[paymentFrequency.value].sumDiscount;
    }
  });
  return totalPrice;
};
